import React from 'react';
import { Stack, Chip, useTheme } from '@mui/material';
import { useTheme as useCustomTheme } from '../../theme/ThemeProvider';

const QuickExamples = ({ examples, onExampleClick, maxWidth = '100%' }) => {
  const theme = useTheme();
  const { darkMode } = useCustomTheme();

  return (
    <Stack 
      direction="row" 
      spacing={1} 
      flexWrap="wrap" 
      justifyContent="center" 
      useFlexGap
      sx={{ maxWidth }}
    >
      {examples.map((example, index) => (
        <Chip
          key={index}
          label={example}
          onClick={() => onExampleClick(example)}
          sx={{
            cursor: 'pointer',
            background: darkMode 
              ? 'rgba(255, 255, 255, 0.1)' 
              : 'rgba(255, 255, 255, 0.8)',
            color: darkMode ? 'rgba(255, 255, 255, 0.9)' : 'rgba(0, 0, 0, 0.8)',
            border: darkMode 
              ? '1px solid rgba(255, 255, 255, 0.2)' 
              : '1px solid rgba(0, 0, 0, 0.1)',
            '&:hover': {
              background: darkMode 
                ? 'rgba(255, 255, 255, 0.2)' 
                : 'rgba(255, 255, 255, 1)',
              transform: 'translateY(-2px)',
              boxShadow: darkMode 
                ? '0 4px 12px rgba(255, 255, 255, 0.1)' 
                : '0 4px 12px rgba(0, 0, 0, 0.1)',
            },
            transition: 'all 0.2s ease',
            fontSize: '0.875rem',
            fontWeight: 500,
          }}
        />
      ))}
    </Stack>
  );
};

export default QuickExamples; 